import React from 'react';
import { IconProps } from '.';

const SvgCheckDouble = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='m8.05 18.611 10.526-12.63-1.152-.961L7.95 16.389l-5.42-5.42-1.06 1.061 6.58 6.581ZM12.576 18.98l10-12-1.152-.96-10 12 1.152.96Z'
      />
    </svg>
  );
};

export default SvgCheckDouble;
